var _path, _mask, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterNavyGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H17C17.2761 0.5 17.5 0.723858 17.5 1V3.66016H4.5V1C4.5 0.723858 4.72386 0.5 5 0.5Z",
    fill: "#9296AC",
    stroke: "#9296AC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4738_2969",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.60352,
    width: 22,
    height: 14.4213,
    rx: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.60352,
    width: 22,
    height: 14.4213,
    rx: 1.5,
    stroke: "#9296AC",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_4738_2969)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 12.9805,
    width: 13,
    height: 12.52,
    rx: 1,
    fill: "#9296AC",
    stroke: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterNavyGrayOutline);
export default __webpack_public_path__ + "static/media/printerNavyGrayOutline.6175709a7c7cf1dc0795decea2001f9a.svg";
export { ForwardRef as ReactComponent };